.aw-search-input {
  max-width: 720px;
}

.zhibi-page-nav {
  margin-bottom: 14px;
}

.zhibi-page-nav .ant-breadcrumb {
  color: #64748b;
  font-size: 13px;
}

.zhibi-page-nav .ant-breadcrumb a {
  color: #64748b;
}

.zhibi-page-nav .ant-breadcrumb li:last-child {
  color: #15202b;
  font-weight: 700;
}

.aw-community-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  margin-top: 16px;
}

.aw-community-loading {
  align-items: center;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  border: 1px dashed #d8e2ec;
  border-radius: 14px;
  color: #64748b;
  display: flex;
  flex-direction: column;
  gap: 14px;
  justify-content: center;
  margin-top: 18px;
  min-height: 220px;
  padding: 32px 16px;
  text-align: center;
}

.aw-community-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 0;
}

.aw-community-card .ant-card-body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 218px;
  min-width: 0;
}

.aw-community-card .ant-card-actions {
  flex: 0 0 auto;
}

.aw-community-card-meta {
  min-width: 0;
}

.aw-community-card-date {
  flex: 0 1 auto;
  max-width: 58%;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.aw-community-card-title {
  margin: 12px 0 8px !important;
  min-height: 54px;
}

.aw-community-card-title a {
  color: #15202b;
}

.aw-community-card-keywords {
  line-height: 1.55;
  margin-bottom: 12px !important;
  min-height: 48px;
}

.aw-merged-note {
  margin: -2px 0 8px !important;
}

.aw-community-card-tags {
  max-height: 58px;
  overflow: hidden;
}

.aw-card-foot {
  margin-top: auto;
  padding-top: 14px;
}

.aw-community-hero {
  margin-bottom: 12px;
}

.aw-community-hero .ant-card-body {
  padding: 14px 18px;
}

.aw-community-hero h2.ant-typography,
.aw-community-hero h4.ant-typography {
  margin: 4px 0 8px;
}

.aw-community-hero .ant-typography {
  margin-bottom: 0;
}

.aw-profile-header {
  border-bottom: 1px solid #eef2f7;
  padding-bottom: 12px;
}

.aw-profile-title {
  min-width: 320px;
}

.aw-profile-merged-note {
  margin: 8px 0 0 !important;
}

.aw-profile-meta {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(2, minmax(160px, 1fr));
  min-width: 420px;
}

.aw-profile-stat {
  background: #fff;
  border: 1px solid #eef2f7;
  border-radius: 10px;
  padding: 8px 10px;
}

.aw-profile-stat strong {
  color: #15202b;
  display: block;
  font-size: 17px;
  font-weight: 800;
  line-height: 1.35;
  margin-top: 6px;
}

.aw-profile-stat strong {
  white-space: nowrap;
}

.aw-profile-content {
  display: grid;
  gap: 12px;
  grid-template-columns: minmax(0, 1fr) minmax(360px, 0.9fr);
  padding-top: 12px;
}

.aw-profile-section {
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 12px;
  padding: 10px 12px;
}

.aw-hero-keywords {
  border-left: 3px solid #1f4e79;
  line-height: 1.6;
  margin: 6px 0 0;
  padding-left: 12px;
}

.aw-current-period {
  white-space: nowrap;
}

.aw-period-select {
  margin-top: 2px;
  max-width: none;
  width: 100%;
}

.aw-topic-card .ant-card-body {
  padding-top: 14px;
}

.aw-topic-toolbar {
  border-bottom: 1px solid #eef2f7;
  margin-bottom: 12px;
  padding-bottom: 12px;
}

.aw-topic-toolbar h3.ant-typography,
.aw-topic-toolbar h5.ant-typography {
  margin: 2px 0 0;
}

.aw-topic-controls {
  align-items: center;
  display: grid;
  gap: 16px;
  grid-template-columns: minmax(340px, 520px) auto auto;
}

.aw-topic-controls .ant-statistic-title {
  margin-bottom: 2px;
}

.aw-topic-controls .ant-statistic-content {
  font-size: 22px;
  line-height: 1.2;
}

.aw-topic-table-footer {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
}

.aw-topic-filter {
  align-items: center;
  color: #64748b;
  display: inline-flex;
  font-size: 13px;
  font-weight: 750;
  gap: 8px;
  margin: 0;
  min-width: min(100%, 260px);
  white-space: nowrap;
}

.aw-topic-filter span {
  flex: 0 0 auto;
}

.aw-topic-filter .ant-input-affix-wrapper {
  border-radius: 999px;
  min-width: 180px;
}

.aw-topic-pagination {
  margin-left: auto;
}

.aw-profile-panel .ant-statistic-title {
  margin-bottom: 2px;
}

.aw-profile-panel .ant-statistic-content {
  font-size: 24px;
  line-height: 1.2;
}

.aw-member-note {
  margin-top: 12px;
}

.aw-member-copy {
  margin-bottom: 0;
}

.aw-member-preview {
  margin-top: 6px;
}

.aw-alert-search {
  max-width: 520px;
}

.aw-alert-filter {
  min-width: 132px;
}

.aw-alert-title-button {
  background: transparent;
  border: 0;
  color: #15202b;
  cursor: pointer;
  display: grid;
  gap: 4px;
  max-width: 100%;
  padding: 0;
  text-align: left;
}

.aw-alert-title-button strong {
  display: -webkit-box;
  line-height: 1.45;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.aw-alert-title-button span {
  color: #64748b;
  display: block;
  font-size: 12px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.aw-source-line {
  display: grid;
  gap: 4px;
  max-width: 100%;
}

.aw-source-line strong {
  color: #15202b;
  line-height: 1.45;
}

.aw-source-line span {
  color: #64748b;
  display: block;
  font-size: 12px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.aw-cluster-link-button {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #1f4e79;
  cursor: pointer;
  font-weight: 700;
  line-height: 1.3;
  max-width: 100%;
  min-height: 30px;
  overflow: hidden;
  padding: 5px 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.aw-cluster-link-button:hover {
  border-color: #93c5fd;
}

.aw-alert-detail {
  display: grid;
  gap: 12px;
}

.aw-alert-detail-summary {
  margin: 10px 0 0 !important;
}

@media (max-width: 1199px) {
  .aw-community-grid {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  }

  .aw-profile-meta,
  .aw-profile-content {
    grid-template-columns: 1fr;
    min-width: 100%;
  }

  .aw-topic-controls {
    grid-template-columns: 1fr auto auto;
    width: 100%;
  }
}

@media (max-width: 576px) {
  .aw-community-grid {
    grid-template-columns: 1fr;
  }

  .aw-profile-stat strong,
  .aw-current-period {
    white-space: normal;
  }

  .aw-topic-controls {
    grid-template-columns: 1fr;
  }

  .aw-alert-search {
    max-width: 100%;
    width: 100%;
  }

  .aw-alert-filter {
    flex: 1 1 160px;
  }
}
